var months = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

export const getLocalDate = (timestamp) => {
	var d = new Date(timestamp);
	var date = `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
	return date;
};

export const getLocalTime = (timestamp) => {
	var d = new Date(timestamp);
	return d.toLocaleTimeString();
};

export const getLastChanged = (timestamp) => {
	let msInDay = 86400000;
	let diff = Date.now() - timestamp;
	if (diff > msInDay) {
		return getLocalDate(timestamp);
	} else {
		return getLocalTime(timestamp);
	}
};
